import { AiFillAndroid, AiFillApple, AiFillChrome } from "react-icons/ai";

export const services = [
  {
    id: 0,
    name: "Android Development",
    icon: <AiFillAndroid />,
    features: [
      "• Full Stack Android Apps",
      "• Free publish on Google Play Store",
      "• Admob & Facebook Ads Integration",
      "• Minimal Cost Maintenance",
      "• App Store Optimization (ASO)",
    ],
  },
  {
    id: 1,
    name: "Web Development",
    icon: <AiFillChrome />,
    features: [
      "• Full Stack Websites in React JS",
      "• UI Development",
      "• Hosting & Maintenance",
      "• Google Adsense Integration",
      "• Seach Engine Optimization (SEO)",
    ],
  },
  {
    id: 2,
    name: "iOS Development",
    icon: <AiFillApple />,
    features: [
      "• Full Stack iOS Apps",
      "• Hosting, Publishing & Maintenance",
      "• Admob & Facebook Ads Integration",
      "• App Store Optimization (ASO)",
      "• Minimal Cost Maintenance",
    ],
  },
];
